import { useEffect, useRef } from "react";

/**
 * Single hosted-checkout form for ALL Razorpay payment types (application fee,
 * student/tuition fee, ATKT, revaluation). Replaces the four near-identical
 * Razorpay*Form components.
 *
 * Driven by a `notes` object: every own-enumerable key with a non-empty value is
 * emitted as a hidden `notes[key]` input, so callers control the note payload
 * (paymentType, studentId|applicationId, feeStructureId, academicYear,
 * installmentNumber, isFullPayment, …) without a per-type component. This also fixes
 * the old student-fee path, which silently dropped installmentNumber/isFullPayment
 * (those inputs were commented out in RazorpayStudentFeeForm).
 *
 * The form auto-submits to Razorpay's embedded checkout on mount.
 */
const RazorpayHostedCheckout = ({ order_id, key_id, user, callback_url, notes = {} }) => {
  const formRef = useRef();

  useEffect(() => {
    if (formRef.current) {
      formRef.current.submit();
    }
  }, []);

  // Keep only meaningful note entries (skip null/undefined/empty-string), and
  // stringify so booleans/numbers post correctly.
  const noteEntries = Object.entries(notes).filter(
    ([, value]) => value !== null && value !== undefined && value !== "",
  );

  return (
    <form
      ref={formRef}
      action="https://api.razorpay.com/v1/checkout/embedded"
      method="POST"
      style={{ display: "none" }}
    >
      <input type="hidden" name="key_id" value={key_id} />
      <input type="hidden" name="order_id" value={order_id} />
      <input type="hidden" name="callback_url" value={callback_url} />
      <input type="hidden" name="prefill[name]" value={user?.name || ""} />
      <input type="hidden" name="prefill[email]" value={user?.email || ""} />
      <input type="hidden" name="prefill[contact]" value={user?.mobile || ""} />

      {noteEntries.map(([key, value]) => (
        <input
          key={key}
          type="hidden"
          name={`notes[${key}]`}
          value={String(value)}
        />
      ))}
    </form>
  );
};

export default RazorpayHostedCheckout;
